import React from 'react';
import { useLocale } from '@platform/core';

export default function ReportsPage() {
  const { t } = useLocale();

  return (
    <div className="plans-page">
      <div className="page-header">
        <h1 className="page-title">Reports</h1>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <div className="stat-card" style={{ textAlign: 'center', padding: 'var(--spacing-xl)', maxWidth: '360px', width: '100%' }}>
          <div style={{ fontSize: '3rem', marginBottom: 'var(--spacing-md)' }}>📄</div>
          <h2 style={{ marginBottom: 'var(--spacing-sm)' }}>Reports</h2>
          <p style={{ color: 'var(--text-secondary)' }}>{t('general.comingSoon') || 'Coming soon'}</p>
        </div>
      </div>
    </div>
  );
}
